module.exports = __webpack_public_path__ + "static/img/sequence-2.342f10f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/sequence-2.jpg
// module id = knvm
// module chunks = 0